/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SdkMessageLog } from '../../models/sdk-message-log';

export interface ScanSdkMessageLogPost$Params {
      body?: SdkMessageLog
}

export function scanSdkMessageLogPost(http: HttpClient, rootUrl: string, params?: ScanSdkMessageLogPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, scanSdkMessageLogPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as VivaLiteScanStrictHttpResponse<void>;
    })
  );
}

scanSdkMessageLogPost.PATH = '/Scan/SDKMessageLog';
